export const debounce = (fn, delay = 1000) => {
    let timer = null;
    return (...args) => {
        clearTimeout(timer);
        // eslint-disable-next-line no-undef
        timer = setTimeout(fn.bind(this, ...args), delay);
    };
};
